import { render, staticRenderFns } from "./ResitrarUsuarios.vue?vue&type=template&id=6da8eb3c&"
import script from "./ResitrarUsuarios.vue?vue&type=script&lang=js&"
export * from "./ResitrarUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports